import { Box, HStack } from '@chakra-ui/react';
import { useRoastVoteMutation } from 'hooks/mutations/roast/useRoastVoteMutation';
import { useGetRoastUserVoteQuery } from 'hooks/queries/roast/useGetRoastUserVoteQuery';

import { useCurrentUser } from 'auth/CurrentUserProvider';

interface RoastVoteButtonProps {
  roastId: string;
  upvoteCount: number;
}

const ChevronUpIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
  </svg>
);

const RoastVoteButton = ({ roastId, upvoteCount }: RoastVoteButtonProps) => {
  const { id: userId } = useCurrentUser();
  const { hasVoted } = useGetRoastUserVoteQuery({ roastId, userId });
  const { mutate: toggleVote } = useRoastVoteMutation();

  return (
    <Box
      as="button"
      display="inline-flex"
      alignItems="center"
      gap="6px"
      px={4}
      py={2.5}
      borderRadius="lg"
      fontSize="14px"
      fontWeight="medium"
      cursor="pointer"
      transition="all 0.15s"
      backgroundColor={hasVoted ? 'rgba(249,115,22,0.15)' : 'whiteAlpha.50'}
      border="1px solid"
      borderColor={hasVoted ? 'rgba(249,115,22,0.3)' : 'whiteAlpha.100'}
      color={hasVoted ? 'orange.300' : 'whiteAlpha.700'}
      _hover={{
        backgroundColor: hasVoted ? 'rgba(249,115,22,0.2)' : 'whiteAlpha.100',
        color: hasVoted ? 'orange.200' : 'white',
      }}
      onClick={() => toggleVote({ roastId })}
    >
      <HStack spacing="6px">
        <ChevronUpIcon />
        <span>{upvoteCount} {hasVoted ? 'Upvoted' : 'Upvote'}</span>
      </HStack>
    </Box>
  );
};

export default RoastVoteButton;
